import React, { useMemo } from 'react';

const makeTexture = (cols, rows) => {
    const chars = ['#', '#', '=', '=', '-', '~', '.', ','];
    const lines = [];
    for (let y = 0; y < rows; y++) {
        let row = '';
        for (let x = 0; x < cols; x++) {
            const v = Math.abs(Math.sin(x * 127.1 + y * 311.7) * 43758.5453) % 1;
            row += chars[Math.floor(v * chars.length)];
        }
        lines.push(row);
    }
    return lines.join('\n');
};

const AsciiBox = ({ children, width = 200, height = 37, fontSize = '1.6rem' }) => {
    const cols = Math.ceil(width / 3);
    const rows = Math.ceil(height / 3.6);
    const texture = useMemo(() => makeTexture(cols, rows), [cols, rows]);

    return (
        <div style={{
            background: 'black',
            color: 'white',
            fontFamily: '"Futura", "Nunito Sans"',
            fontWeight: 'bold',
            fontSize,
            fontStyle: 'italic',
            width,
            height,
            marginBottom: '15px',
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <pre style={{
                position: 'absolute',
                top: 0,
                left: 0,
                margin: 0,
                padding: 0,
                fontFamily: 'monospace',
                fontSize: '5px',
                lineHeight: '0.72',
                letterSpacing: '0px',
                color: 'white',
                opacity: 0.28,
                userSelect: 'none',
                pointerEvents: 'none',
                whiteSpace: 'pre',
                zIndex: 0,
            }}>
                {texture}
            </pre>
            <span style={{ position: 'relative', zIndex: 1 }}>{children}</span>
        </div>
    );
};

export default AsciiBox;
